import { createUseStyles } from 'react-jss'
import { LightTheme } from '../../../../theme'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  container: {
    background: theme.colors.white,
    borderBottom: `1px solid ${theme.colors.shadow}`,
    padding: '12px 16px',
    width: 'calc(100% - 32px)'
  },
  flex: {
    flex: 1
  },
  icon: {
    cursor: 'pointer',
    '&:not(:first-child)': {
      marginLeft: 20
    },
    '&:hover > path': {
      fill: theme.colors.yellow
    }
  },
  user: {
    cursor: 'pointer',
    marginLeft: 24,
    textDecoration: 'none'
  },
  text: {
    paddingLeft: 12
  }
}))
